import { getAllRecords } from './offlineStorage';

/**
 * Merge offline records with server data
 * Shows offline-created records in lists before sync
 * Prevents duplicates by matching serverId with localId
 */
export const mergeOfflineData = async (serverData, collection, transformFn) => {
    try {
        const offlineRecords = await getAllRecords(collection);
        const unsyncedRecords = offlineRecords.filter((r) => r.syncStatus !== 'SYNCED' || !r.serverId);

        // Create a map of server IDs to avoid duplicates
        const serverIdMap = new Map();
        serverData.forEach((item) => {
            if (item._id) {
                serverIdMap.set(item._id.toString(), true);
            }
        });

        // Transform offline records to match server data format
        const transformedOffline = unsyncedRecords
            .map((record) => {
                // Skip if this record was already synced and exists in server data
                if (record.serverId && serverIdMap.has(record.serverId.toString())) {
                    return null;
                }

                const base = transformFn ? transformFn(record) : record.payload;
                return {
                    ...base,
                    _id: record.serverId || record.localId, // Use serverId if available, else localId
                    localId: record.localId,
                    isOffline: !record.serverId,
                    synced: record.synced,
                    syncStatus: record.syncStatus || (record.synced ? 'SYNCED' : 'PENDING'),
                    createdAt: record.createdAt,
                    updatedAt: record.updatedAt,
                };
            })
            .filter(Boolean); // Remove null entries

        // Merge and sort by date (newest first)
        const merged = [...serverData, ...transformedOffline].sort((a, b) => {
            const dateA = new Date(a.createdAt || a.saleDate || a.expenseDate || a.invoiceDate || a.purchaseDate || a.movementDate || a.createdAt || 0);
            const dateB = new Date(b.createdAt || b.saleDate || b.expenseDate || b.invoiceDate || b.purchaseDate || b.movementDate || b.createdAt || 0);
            return dateB - dateA;
        });

        return merged;
    } catch (error) {
        console.error('Error merging offline data:', error);
        return serverData; // Return server data only on error
    }
};

